import { render } from "./Image.vue?vue&type=template&id=33f74979&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=33f74979&scoped=true&lang=less"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3fa629ad-4e49-4135-b708-61865bcdea83/workspace/moon_eoR5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f74979"]])

export default __exports__